// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"Form_formTitle__26qbg","background":"Form_background__2_Iij","submitbtn":"Form_submitbtn__28DEc"};